{
  "8174f49c-e3af-43de-bca0-ef6a440c923e": {
    "1000": "Ett okänt fel inträffade, försök igen eller kontakta support"
  },
  "9337844a-5b6f-4b1f-a5dc-552926bdaf19": {
    "1000": "Max 8 planer är tillåtet",
    "1001": "Max 120 lag är tillåtna",
    "1002": "Minst 2st lag krävs"
  }
}
